export const saveAnswer = (audit_id, data) => {
    const local_data=JSON.parse(localStorage.getItem(`save_${audit_id}`));
    if(data.hasOwnProperty("result")){
        local_data["data"][data.part_name][data.category][data.level][data.task_number]["result"]=data.result;   
    }
    if(data.hasOwnProperty("comment")){
        local_data["data"][data.part_name][data.category][data.level][data.task_number]["comment"]=data.comment;   
    }
    local_data["data"][data.part_name][data.category][data.level][data.task_number]["changed"]=true;
    local_data["saving"]=true;
    localStorage.setItem(`save_${audit_id}`,JSON.stringify(local_data));
} 